export const styles = {
  loadingStateContainer: {
    padding: 2,
  },
  loadingSkeleton: {
    marginTop: 2,
    height: 50,
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 2,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  refreshIcon: {
    '@keyframes spin': {
      from: { transform: 'rotate(0deg)' },
      to: { transform: 'rotate(360deg)' },
    },
    animation: 'spin 2s linear infinite',
    fontSize: '20px',
    color: '#2196f3',
  },
  headerActions: {
    display: 'flex',
    gap: 2,
  },
  label: {
    whiteSpace: 'nowrap',
    fontSize: '1rem',
  },
  messageLabel: {
    whiteSpace: 'break-spaces',
    fontSize: '1rem',
    marginRight: 1,
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  progressBarContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  progressBar: {
    height: 20,
    borderRadius: 5,
    flexGrow: 1,
  },
  progressBarText: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#fff',
    fontWeight: 'bold',
  },
  downloadFileBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 2,
  },
  sourceFilesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    marginTop: 1,
  },
  downloadSourceFileButton: {
    marginBottom: 1,
  },
  errorStateContainer: {
    padding: 2,
    border: '1px solid #f44336',
    borderRadius: 4,
    backgroundColor: '#ffebee',
    color: '#f44336',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
  },
  errorStateTitle: {
    fontWeight: 'bold',
  },
  spinner: {
    color: '#007bff',
    width: '24px',
    height: '24px',
    marginLeft: 1,
  },
};
